<template>
  <div>
    <Navigation />

    <div class="row tableUsers">

      <div v-if="addNewVoucher" class="popUp-overlay"></div>
      <div v-show="addNewVoucher" class="popUp-dialogScrollable zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-6">
                  <label class="floatLeft" for="service_id">Provider</label>
                  <select v-model="service_id" v-bind:class="errorMsg && !service_id ? 'border-red' : 'border-none'" class="form-control form-control-sm">
                    <option v-bind:key="index" v-for="(provider, index) in providerFilterSelect"
                      v-bind:value="provider.id">
                      {{ provider.name_mk }}
                    </option>

                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_mk">Name MK</label>
                    <input id="name_mk" v-model="name_mk" v-bind:class="errorMsg && !name_mk ? 'border-red' : 'border-none'" type="text" name="name_mk" class="form-control" placeholder
                      required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_mk">Description MK </label>
                    <textarea id="description_mk" v-model="description_mk" v-bind:class="errorMsg && !description_mk ? 'border-red' : 'border-none'" type="text" name="description_mk"
                      class="form-control" placeholder required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_al">Name AL</label>
                    <input id="name_al" v-model="name_al" v-bind:class="errorMsg && !name_al ? 'border-red' : 'border-none'" type="text" name="name_al" class="form-control" placeholder
                      required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_al">Description AL </label>
                    <textarea id="description_al" v-model="description_al" v-bind:class="errorMsg && !description_al ? 'border-red' : 'border-none'" type="text" name="description_al"
                      class="form-control" placeholder required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_en">Name EN</label>
                    <input id="name_en" v-model="name_en" v-bind:class="errorMsg && !name_en ? 'border-red' : 'border-none'" type="text" name="name_en" class="form-control" placeholder
                      required="required" data-error="error" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_en">Description EN </label>
                    <textarea id="description_en" v-model="description_en"  v-bind:class="errorMsg && !description_en ? 'border-red' : 'border-none'" type="text" name="description_en"
                      class="form-control" placeholder required="required" data-error="error" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="points">Points</label>
                    <input id="points" v-model="points" v-bind:class="errorMsg && !points ? 'border-red' : 'border-none'" type="number" step="0.01" name="points" class="form-control"
                      placeholder required="required" data-error="error" />
                  </div>
                </div>



                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="value">Value</label>
                    <input id="value" v-model="value" type="number" v-bind:class="errorMsg && !value ? 'border-red' : 'border-none'" step="0.01" name="value" class="form-control"
                      placeholder required="required" data-error="error" />
                  </div>
                </div>

              </div>
            <div v-if="errorMsg" class="row">
                  <div class="col-md-12">
                    <div class="error-infobox">
                         {{ errorMsg }}
                    </div>
                  </div>
                </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input @click.prevent="addVoucher()" type="submit" class="btn btnDark btn-success btn-send pointer"
                    value="Submit" />
                  <input v-on:click="addNewVoucher = false;
                  errorMsg = ''; clearForm();
                                                                                                                        " type="cancel"
                    class="btn btn-secondary pointer button-width-helper" value="Cancel" />
                </div>
              </div>

            </div>

          </form>
        </div>
      </div>
      <div v-if=" editVoucher " class="popUp-overlay"></div>
      <div v-show="editVoucher" class="popUp-dialogScrollable zHelper">  <!-- popUp changed to popUp-dialogScrollable -->
                <div class="col-md-12">
                  <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-6">
                  <label class="floatLeft" for="service_id">Provider</label>
                  <select v-model="service_id" class="form-control form-control-sm">
                    <option v-bind:key="index" v-for="(provider, index) in providerFilterSelect"
                      v-bind:value="provider.id">
                      {{ provider.name_mk }}
                    </option>

                  </select>
                  <input type="hidden" v-model=" voucher_type_id " value />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_mk">Name MK</label>
                    <input id="name_mk" v-model="name_mk" type="text" name="name_mk" class="form-control" placeholder
                      required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_mk">Description MK </label>
                    <textarea id="description_mk" v-model="description_mk" type="text" name="description_mk"
                      class="form-control" placeholder required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_al">Name AL</label>
                    <input id="name_al" v-model="name_al" type="text" name="name_al" class="form-control" placeholder
                      required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_al">Description AL </label>
                    <textarea id="description_al" v-model="description_al" type="text" name="description_al"
                      class="form-control" placeholder required="required" data-error="error" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="name_en">Name EN</label>
                    <input id="name_en" v-model="name_en" type="text" name="name_en" class="form-control" placeholder
                      required="required" data-error="error" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="description_en">Description EN </label>
                    <textarea id="description_en" v-model="description_en" type="text" name="description_en"
                      class="form-control" placeholder required="required" data-error="error" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="points">Points</label>
                    <input id="points" v-model="points" type="number" step="0.01" name="points" class="form-control"
                      placeholder required="required" data-error="error" />
                  </div>
                </div>



                <div class="col-md-6">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="value">Value</label>
                    <input id="value" v-model="value" type="number" step="0.01" name="value" class="form-control"
                      placeholder required="required" data-error="error" />
                  </div>
                </div>

              </div>
            
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input @click.prevent="updateVoucher()" type="submit" class="btn btnDark btn-success btn-send pointer"
                    value="Submit" />
                  <input v-on:click="clearForm();editVoucher = false; 
                  errorMsg = '';
                                                                                                                        " type="cancel"
                    class="btn btn-secondary pointer button-width-helper" value="Cancel" />
                </div>
              </div>

            </div>

          </form>
                </div>

            </div>
      <div v-if=" downloadActivity " class="popUp-overlay"></div>
      <div v-show=" downloadActivity " class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages">
              <div class="controls">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group has-error has-danger">
                      <label class="floatLeft" for="userData">Export Vouchers (latest 3000 records) </label>
                    </div>
                  </div>
                </div>
                <div class="row floatLeft">
                  <div class="col-md-12">
                    <v-btn v-on:click=" ExportResults(); " class="btn darkGreen btn-success pointer"
                      value="Download">Download</v-btn>
                    <v-btn v-on:click=" downloadActivity = false " type="cancel" class="btn btn-secondary pointer"
                      value="Cancel">Cancel</v-btn>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12 col-md-4 tableName text-left pl-4">
                  <a href="#" class="btn btn-round btn-icon btn-sm createNew mt-1" title="Add new voucher type"
                    v-on:click=" addNew() ">
                    <i class="fas fa-plus"></i>
                  </a>
                  Vouchers Types
                </div>
                <div class="col-sm-12 col-md-2 mt-3">
                  <!-- Filter by type -->
                </div>
                <div class="col-sm-12 col-md-3 mt-3">
                  <!-- Filter by Provider -->
                </div>
                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter">
                    <form class="
                        form-inline
                        md-form
                        floatRight
                        searchDiv
                        form-sm
                        active-darkGreen-2
                        mt-3
                      ">
                      <input v-model=" searchVoucherType " name="query" v-on:keyup=" filterVoucherTypesResults() "
                        class="form-control borderNone form-control-sm mr-3" type="text" placeholder="Search"
                        aria-label="Search" />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div v-if=" voucherStatusAction " class="popUp-overlay"></div>
              <div v-show=" voucherStatusAction " class="popUp-dialog zHelper">
                <div class="col-md-12">
                  <form @submit.prevent>
                    <div class="messages"></div>
                    <div class="controls">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group has-error has-danger">
                            <label for="form_name">Are you sure you want to proceed with the action
                              ?</label>
                            <label v-if=" errorMsg " class="error-infobox" style="margin-bottom: 0px">{{ errorMsg }}</label>
                            <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <input @submit.prevent v-on:click=" changeVoucherStatus() " type="submit" class="
                              btn
                              danger
                              btnDark
                              btn-success btn-send
                              pointer
                            " value="Yes" />
                          <input v-on:click=" voucherStatusAction = false " type="cancel"
                            class="btn btnDark btn-success pointer" value="No" />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table id="datatable" class="
                      table table-striped table-bordered
                      dataTable
                      dtr-inline
                    " cellspacing="0" width="100%" role="grid" aria-describedby="datatable_info" style="width: 100%">
                    <thead>
                      <tr role="row">
                        <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1" colspan="1"
                          style="width: 229px" aria-sort="ascending" aria-label="Name: activate to sort column descending"
                          v-on:click=" sortVouchersTypesResults(1) ">
                          Voucher type
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVouchersTypesResults(2) ">
                          Provider
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVouchersTypesResults(3) ">
                          Total vouchers
                        </th>
                        <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1" colspan="1"
                          style="width: 229px" aria-sort="ascending" aria-label="Name: activate to sort column descending"
                          v-on:click=" sortVouchersTypesResults(4) ">
                          Free
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVouchersTypesResults(5) ">
                          Assigned
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVouchersTypesResults(6) ">
                          Used
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVouchersTypesResults(6) ">
                          Status
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending">
                          Change status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr role="row" v-bind:key=" index " v-for="( voucher, index ) in  voucher_type_stats " v-bind:class="
                        [
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]
                      ">
                        <td tabindex="0" class="sorting_1">
                          {{ voucher.type_voucher }}
                        </td>
                        <td>{{ voucher.provider }}</td>
                        <td>
                          {{ voucher.total_vouchers }}
                        </td>
                        <td>{{ voucher.free_vouchers }}</td>
                        <td>{{ voucher.assigned_vouchers }}</td>
                        <td>{{ voucher.used_vouchers }}</td>
                        <td>
                          <span v-if=" voucher.voucher_status == 0 ">Not Active</span>
                          <span v-else>Active</span>
                        </td>

                        <td class="text-right pb-0 pr-0">
                          <div class="actions_on_user pr-2" v-if=" voucher.voucher_status != 0 ">
                            <a href="#" class="
                                btn btn-round btn-danger btn-icon btn-sm
                                remove
                                mr-2
                              " v-on:click="
                                disableVoucher = voucher.id;
                                voucherStatusAction = true;
                              " id="deactivateVoucher">
                              <i class="fas fa-minus-circle"></i>
                            </a>
                            <label class="activity_label" for="deactivateVoucher">Deactivate</label>
                          </div>
                          <div class="actions_on_user pr-2" v-else>
                            <a href="#" class="
                                btn btn-round btn-success btn-icon btn-sm
                                remove
                                mr-2
                              " v-on:click="
                                disableVoucher = voucher.id;
                                voucherStatusAction = true;
                              " id="activateVoucher">
                              <i class="far fa-check-circle"></i>
                            </a>
                            <label class="activity_label" for="activateVoucher">Activate</label>
                          </div>

                          <div class="actions_on_user pr-2">
                            <a href="#" class="btn btn-round btn-edit btn-icon btn-sm edit"
                                                             @click.prevent=" edit(voucher.id) " id="edit">
                                                            <i class="far fa-edit"></i>
                                                        </a>
                                                        <label class="activity_label" for="edit">Edit</label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <pagination :meta_data=" meta_data_voucherType " v-on:next=" fetchVoucherTypeResults "></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
      <!-- IMPORT VOUCHER COMPONENTS STARTS HERE -->
      <div v-if=" importFlag " class="popUp-overlay"></div>
      <div v-show=" importFlag " class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-sm-12 form-group text-left row pl-3">
                  <div class="col-sm-6">
                    <label for="providerDropdown">Choose voucher provider</label>
                    <select class="form-control form-control-sm" id="providerDropdown" @change=" onOptionChange "
                      v-model=" selectedProviderId " required>
                      <option v-bind:key=" index " v-for="( provider, index ) in  dropDownProviderInfo "
                        v-bind:value=" provider.id ">
                        {{ provider.name_mk }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6" v-if=" dropDownVoucherInfo != null ">
                    <label for="voucherDropdown">Choose voucher type</label>
                    <select class="form-control form-control-sm" id="voucherDropdown" v-model=" selectedVoucherId "
                      @change=" onOptionChangeVoucher " required>
                      <option v-bind:key=" index " v-for="( voucher_type, index ) in  dropDownVoucherInfo "
                        v-bind:value=" voucher_type.id ">
                        {{ voucher_type.name_mk }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row pl-1">
                <div class="form-group text-left col-sm-12">
                  <label for="exampleFormControlFile1">Choose file to upload</label>
            <input type="file" class="form-control-file" id="importFile" v-bind="selectedFile" @change="onFileChange" :disabled="!isFileUploadEnabled" required />
                </div>
              </div>
              <div class="form-group has-error has-danger">
                <label v-if=" errorMsg " class="floatLeft error-infobox">{{
                  errorMsg
                  }}</label>
              </div>
            </div>
            <div class="row floatLeft">
              <div class="col-md-12">
          <input @click.prevent="importVouchersPost()" type="submit" class="btn btnDark btn-success btn-send pointer" value="Submit" id="submit_import" :disabled="!isFileUploadEnabled" />
                <input v-on:click=" closeImport() " type="cancel" class="btn btn-secondary pointer button-width-helper"
                  value="Cancel" />
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- IMPORT VOUCHER COMPONENT ENDS HERE -->
      <div></div>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12 col-md-2 tableName text-left pl-4">
                  Vouchers
                </div>
                <!-- IMPORT VOUCHER BTN TRIGGER -->
                <div class="col-sm-12 col-md-4 mt-3 text-left">
                  <div class="row pointer mt-1" v-on:click="
                    importVouchers();
                    loadProviderDropdown();
                  ">
                    <a href="#" class="btn btn-round btn-icon btn-sm createNew mt-1" title="Add new vouchers">
                      <i class="fas fa-plus"></i>
                    </a>
                    <div class="mt-2 ml-2">Import Vouchers</div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 mt-1">
                  <div id="datatable_filter" class="dataTables_filter">
                    <form class="
                        form-inline
                        md-form
                        floatRight
                        searchDiv
                        form-sm
                        active-darkGreen-2
                      ">
                      <input v-model=" searchVoucher " name="query" v-on:keyup=" filterVoucherResults() "
                        v-on:paste=" filterVoucherResults " class="form-control borderNone form-control-sm mr-3" type="text"
                        placeholder="Search" aria-label="Search" />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
                <!-- IMPORT VOUCHER BTN TRIGGER -->
                <div class="col-sm-12 col-md-6 mt-3 text-left">
                  <!--Import vouchers -->


                </div>
              </div>
              <div class="row filterbyprovider">
                <div class="col-sm-12 col-md-2 mt-1 text-left pl-4 heading">
                  Filter by provider:
                </div>
                <div class="col-sm-12 col-md-2 mt-1 text-left">
                  <select v-model=" filterProvider " class="form-control form-control-sm"
                    v-on:change=" filterVoucherResults() ">
                    <option v-bind:key=" index " v-for="( provider, index ) in  providerFilterSelect "
                      v-bind:value=" provider.id ">
                      {{ provider.name_mk }}
                    </option>

                  </select>
                </div>
                <div class="col-sm-12 col-md-8 mt-1 text-left"></div>
              </div>
              <div class="row filterbystatus">
                <div class="col-sm-12 col-md-2 mt-1 text-left pl-4 heading">
                  Filter by status:
                </div>
                <div class="col-sm-12 col-md-5 mt-1 text-left">
                  <input type="checkbox" id="free_status" value="1" v-model=" filterStatus "
                    v-on:change=" filterVoucherResults() " />
                  <label for="free_status">Free</label>
                  <input type="checkbox" id="assigned_status" value="2" v-model=" filterStatus "
                    v-on:change=" filterVoucherResults() " />
                  <label for="assigned_status">Assigned</label>
                  <input type="checkbox" id="used_status" value="0" v-model=" filterStatus "
                    v-on:change=" filterVoucherResults() " />
                  <label for="used_status">Used</label>
                </div>
                <div class="col-sm-12 col-md-5 mt-1 text-right heading clearFilter" type="reset">
                  <button @click=" ClearFilters() ">Clear filters</button>
                </div>


              </div>
              <div class="row">
                <div class="col-sm-12 min-table-height">
                  <table id="datatable" class="
                      table table-striped table-bordered
                      dataTable
                      dtr-inline
                    " cellspacing="0" width="100%" role="grid" aria-describedby="datatable_info" style="width: 100%">
                    <thead>
                      <tr role="row">
                        <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1" colspan="1"
                          style="width: 229px" aria-sort="ascending" aria-label="Name: activate to sort column descending"
                          v-on:click=" sortVoucherResults(6) ">
                          Provider Name
                        </th>
                        <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1" colspan="1"
                          style="width: 229px" aria-sort="ascending" aria-label="Name: activate to sort column descending"
                          v-on:click=" sortVoucherResults(1) ">
                          Voucher Type Name
                        </th>
                        <th class="sorting_asc" tabindex="0" aria-controls="datatable" rowspan="1" colspan="1"
                          style="width: 229px" aria-sort="ascending" aria-label="Name: activate to sort column descending"
                          v-on:click=" sortVoucherResults(5) ">
                          Codes
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVoucherResults(2) ">
                          Value
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVoucherResults(4) ">
                          Status
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px" aria-label="Actions: activate to sort column ascending"
                          v-on:click=" sortVoucherResults(3) ">
                          User
                        </th>
                        <th class="disabled-sorting sorting" tabindex="0" aria-controls="datatable" rowspan="1"
                          colspan="1" style="width: 230px">
                          Assigned on
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr role="row" v-bind:key=" index " v-for="( voucher, index ) in  voucher_stats " v-bind:class="
                        [
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]
                      ">
                        <td tabindex="0" class="sorting_1">
                          {{ voucher.service_name }}
                        </td>
                        <td>
                          {{ voucher.name_mk }}
                        </td>
                        <td>{{ voucher.code }}</td>
                        <td>{{ voucher.value }}</td>
                        <td>
                          <span v-if=" voucher.status == 0 ">Used</span>
                          <span v-else-if=" voucher.status == 1 "> Free</span>
                          <span v-else>Assigned</span>
                        </td>
                        <td>
                          <span v-if=" voucher.username ">{{
                            voucher.username
                            }}</span>
                          <span v-else>Not assigned to user</span>
                        </td>
                        <td>

                          <span v-if=" voucher.assigned_on ">{{
                            voucher.assigned_on
                            }}</span>
                          <span v-else>/</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <pagination :meta_data=" meta_data_voucher " v-on:next=" fetchVoucherResults "
                v-on:ExportResults=" triggerDownload "></pagination>
            </div>
          </div>
          <!-- end content-->
        </div>
        <!--  end card  -->
      </div>
      <!-- end col-md-12 -->
    </div>
  </div>
</template>
<script>
import Navigation from "@/views/Navigation.vue";
import axios from 'axios';
import Pagination from "@/components/Pagination.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
  },
  data() {
    return {
      addNewVoucher: false,
      name_mk: null,
      description_mk: null,
      name_al: null,
      description_al: null,
      name_en: null,
      description_en: null,
      points: null,
      value: null,
      service_id: null,
      voucher_type_stats: null,
      searchVoucherType: null,
      orderVoucherType: null,
      sortVoucherType: null,
      dirVoucherType: null,
      // Import spliter
      importFlag: false,
      chooseProvider: null,
      chooseVoucherType: null,
      dropDownVoucherInfo: null,
      dropDownProviderInfo: null,
      selectedVoucherId: null,
      selectedProviderId: null,
      selectedFile: null,
      filterStatus: [],
      disableVoucher: null,
      voucherStatusAction: false,
      filterProvider: null,
      providerFilterSelect: [],
      voucher_type_id: null,
      // separator
      editVoucher: false,
      errorMsg: '',
      meta_data_voucherType: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
      // Split voucher and provider
      voucher_stats: null,
      searchVoucher: null,
      orderVoucher: null,
      sortVoucher: null,
      dirVoucher: 0,
      meta_data_voucher: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
        exportData: true
      },
      downloadActivity: false,
      dateFrom: null,
      dateTo: new Date().toISOString().substr(0, 10),
    };
  },
  mounted() {
    this.fetchVoucherTypeResults(
      this.meta_data_voucherType.current_page,
      this.meta_data_voucherType.perpage,
      this.searchVoucherType,
      this.orderVoucherType,
      this.sortVoucherType,
      this.meta_data_voucherType.total
    );
    this.fetchVoucherResults(
      this.meta_data_voucher.current_page,
      this.meta_data_voucher.perpage,
      this.searchVoucher,
      this.orderVoucher,
      this.sortVoucher,
      this.meta_data_voucher.total
    );
    this.loadProviderFilter();
    document.addEventListener("keydown", this.onEscapeKey);

  },
  computed: {
     isFileUploadEnabled() {
         return this.selectedProviderId !== null && this.selectedVoucherId !== null;
     }
  },
  destroyed(){
        document.removeEventListener("keydown", this.onEscapeKey);
  },
  methods: {
     onEscapeKey(event){ 
      if(event.key === 'Escape' && this.addNewVoucher){
        this.addNewVoucher = false;
        this.clearForm();
      }
      if(event.key === 'Escape' && this.editVoucher){
        this.editVoucher = false;
        this.clearForm();
      }
      if(event.key === 'Escape' && this.importFlag){
        this.importFlag = false;
        this.closeImport();
      }
      if(event.key === 'Escape' && this.downloadActivity){
        this.downloadActivity = false;
      }
      if(event.key === 'Escape' && this.voucherStatusAction){
        this.voucherStatusAction = false;
      }
    },
    //  FOR Voucher TYPES --->>>
    edit(id){
      this.$data.editVoucher = true;
      this.errorMsg = '';
      this.voucher_type_id = id;

      axios
                .get(store.state.BASE_URI + "admin/vouchers/fetch_vtype", {
                    headers: { Authorization: localStorage.getItem("accessToken") },
                    params: {
                        id,
                    },
                })
                .then((res) => {
                    this.service_id = res.data.content.service_id;
                    this.name_mk = res.data.content.name_mk;
                    this.name_al = res.data.content.name_al;
                    this.name_en = res.data.content.name_en;
                    this.description_mk = res.data.content.description_mk;
                    this.description_en = res.data.content.description_en;
                    this.description_al = res.data.content.description_al;
                                    this.value = res.data.content.value;
                    this.points = res.data.content.points;

                    this.loadProviderDropdown();

                });
    },
    addNew() {
      this.$data.addNewVoucher = true;
      this.errorMsg = '';
    },
    addVoucher() {
      var post_data = {
        name_mk: this.name_mk,
        description_mk: this.description_mk,
        name_al: this.name_al,
        description_al: this.description_al,
        name_en: this.name_en,
        description_en: this.description_en,
        points: this.points,
        value: this.value,
        is_active: 1,
        service_id: this.service_id

      }
      console.log(post_data)
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );

      axios
        .post(store.state.BASE_URI + "admin/vouchers/create_voucher_type", {
          params: post_data,
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.addNewVoucher = false;
          this.fetchResults(
            this.meta_data.page,
            this.meta_data.perpage,
            this.search,
            this.order,
            this.sort
          );
          this.errorMsg = "";
          this.$toasted
            .show(response.data.message, {
              type: "success",
            })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
          }
        });
    },

    clearForm() {
            this.service_id = false;
            this.name_mk = '';
            this.description_mk = '';
            this.name_al = '';
            this.description_al = '';
            this.name_en = '';
            this.description_en = '';
            this.points = '';
            this.value = '';
            this.voucher_type_id = '';
            this.notifyMsg = '';
            this.errorText = '';
        },
    updateVoucher(){

      var post_data = {
        name_mk: this.name_mk,
        description_mk: this.description_mk,
        name_al: this.name_al,
        description_al: this.description_al,
        name_en: this.name_en,
        description_en: this.description_en,
        points: this.points,
        value: this.value,
        service_id: this.service_id,
        id: this.voucher_type_id

      }

      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
                "accessToken"
            );
            axios
                .post(store.state.BASE_URI + "admin/vouchers/update", {
                    params: post_data,
                    headers: {
                        "Content-Type": "text/plain;charset=utf-8",
                    },
                })
                .then((response) => {
                    this.editVoucher = false;
                    this.fetchResults(
                        this.meta_data.page,
                        this.meta_data.perpage,
                        this.search,
                        this.order,
                        this.sort
                    );
                    this.$toasted
                        .show(response.data.message, {
                            type: "success",
                        })
                        .goAway(2000);
                        clearForm();
                })
                .catch((error) => {
                    if (error) {
                        this.errorMsg = error.response.data.message;
                        console.log(error.response.data.message);
                        this.$toasted
                            .show(this.errorMsg, {
                                type: "error",
                            })
                            .goAway(2000);
                    }
                });
    },

    changeVoucherStatus() {
      axios.defaults.headers.common['Authorization'] =
        localStorage.getItem('accessToken');
      console.log(this.disableVoucher);
      axios
        .post(
          store.state.BASE_URI + 'admin/vouchers/change_voucher_type_status',
          {
            params: {
              vt_id: this.disableVoucher,
            },
            headers: {
              'Content-Type': 'text/plain;charset=utf-8',
            },
          }
        )
        .then((response) => {
          this.fetchVoucherTypeResults();
          this.$data.voucherStatusAction = false;
          // TODO: add toast notification
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
          }
        });
    },
    sortVouchersTypesResults(order) {
      this.dirVoucherType++;
      this.orderVoucherType = order;

      if (this.dirVoucherType % 2 == 0) this.sortVoucherType = 'desc';
      else this.sortVoucherType = 'asc';
      this.fetchVoucherTypeResults(
        this.meta_data_voucherType.current_page,
        this.meta_data_voucherType.perpage,
        this.searchVoucherType,
        this.orderVoucherType,
        this.sortVoucherType
      );
    },
    filterVoucherTypesResults() {
      this.meta_data_voucherType.current_page = 1;
      this.fetchVoucherTypeResults(
        this.meta_data_voucherType.current_page,
        this.meta_data_voucherType.perpage,
        this.searchVoucherType,
        this.orderVoucherType,
        this.sortVoucherType
      );
    },
    fetchVoucherTypeResults(
      page = this.meta_data_voucherType.current_page,
      perpage = this.meta_data_voucherType.perpage,
      search = this.searchVoucherType,
      order = this.orderVoucherType,
      sort = this.sortVoucherType,
      total = this.meta_data_voucherType.total
    ) {
      axios
        .get(store.state.BASE_URI + 'admin/vouchers/load_vouchers_types', {
          headers: { Authorization: localStorage.getItem('accessToken') },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            total,
          },
        })
        .then((res) => {
          this.voucher_type_stats = res.data.results.voucher_stats;
          var pagination = res.data.results.pagination;
          this.meta_data_voucherType.last_page = pagination.last_page;
          this.meta_data_voucherType.current_page = pagination.current_page;
          this.meta_data_voucherType.prev_page_url = pagination.prev_page_url;
          this.meta_data_voucherType.perpage = pagination.perpage;
          this.meta_data_voucherType.search = pagination.search;
          this.meta_data_voucherType.total = pagination.total;
          console.log(this.voucher_type_stats);
        });
    },
    //  FOR Voucher --->>>
    // sort
    sortVoucherResults(order) {
      this.dirVoucher++;
      this.orderVoucher = order;

      if (this.dirVoucher % 2 == 0) this.sortVoucher = 'desc';
      else { this.sortVoucher = 'asc' };
      this.fetchVoucherResults(
        this.meta_data_voucher.current_page,
        this.meta_data_voucher.perpage,
        this.searchVoucher,
        this.orderVoucher,
        this.sortVoucher
      );
    },
    // filter
    filterVoucherResults() {
      this.meta_data_voucher.current_page = 1;
      this.fetchVoucherResults(
        this.meta_data_voucher.current_page,
        this.meta_data_voucher.perpage,
        this.searchVoucher,
        this.orderVoucher,
        this.sortVoucher,
        this.filterStatus,
        this.filterProvider
      );
    },
    // fetch
    fetchVoucherResults(
      page = this.meta_data_voucher.current_page,
      perpage = this.meta_data_voucher.perpage,
      search = this.searchVoucher,
      order = this.orderVoucher,
      sort = this.sortVoucher,
      status = this.filterStatus,
      total = this.meta_data_voucher.total,
      provider = this.filterProvider
    ) {
      axios
        .get(store.state.BASE_URI + 'admin/vouchers/load_vouchers_stats_info', {
          headers: { Authorization: localStorage.getItem('accessToken') },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            status,
            total,
            provider
          },
        })
        .then((res) => {
          this.voucher_stats = res.data.results.voucher_stats;
          var pagination = res.data.results.pagination;
          this.meta_data_voucher.last_page = pagination.last_page;
          this.meta_data_voucher.current_page = pagination.current_page;
          this.meta_data_voucher.prev_page_url = pagination.prev_page_url;
          this.meta_data_voucher.perpage = pagination.perpage;
          this.meta_data_voucher.search = pagination.search;
          this.meta_data_voucher.total = pagination.total;
        });
    },
    // Import VOUCHERS
    importVouchers() {
      this.importFlag = true;
    },
    validateForm() {
      const btn = document.querySelector('#submit_import');

      if (
        typeof this.selectedFile == 'undefined' ||
        this.selectedFile == null ||
        this.selectedProviderId == null ||
        this.selectedVoucherId == null
      ) {
        btn.disabled = true;
        return true;
      } else {
        btn.disabled = false;
        return false;
      }
    },
    importVouchersPost() {
      if (!this.validateForm()) {
        // POST HERE
        let formData = new FormData();
        formData.append('import_file', this.selectedFile);
        formData.append('providerId', this.selectedProviderId);
        formData.append('voucherTypeId', this.selectedVoucherId);
        axios.defaults.headers.common['Authorization'] =
          localStorage.getItem('accessToken');
        axios
          .post(
            store.state.BASE_URI + 'admin/vouchers/import_new_vouchers',
            formData,
            {
              headers: { 'content-type': 'multipart/form-data' },
            }
          )
          .then((response) => {
            this.importFlag = false;
            this.selectedFile = null;
            this.selectedProviderId = null;
            this.selectedVoucherId = null;
            this.closeImport();
            this.fetchVoucherResults();
            this.$toasted
              .show(response.data.message, {
                type: 'success',
              })
              .goAway(2000);
          })
          .catch((error) => {
            if (error) {
              this.errorMsg = error.response.data.message;
              this.fetchVoucherResults();
            }
          });
      } else {
        this.importFlag = true;
        this.errorMsg = 'please fill all fields';
      }
    },
    closeImport() {
      this.importFlag = false;
      this.errorMsg = '';
      this.selectedVoucherId =
        this.selectedProviderId =
        this.selectedFile =
        null;
      document.getElementById('importFile').value = '';
    },
    //  Load Data for dropdown
    loadProviderDropdown() {
      axios
        .get(store.state.BASE_URI + 'admin/vouchers/load_providers_vtypes', {
          headers: { Authorization: localStorage.getItem('accessToken') },
          params: {},
        })
        .then((res) => {
          this.dropDownProviderInfo = res.data.results.providers;
        });
    },
    onOptionChange(e) {
      this.validateForm();
      axios
        .get(store.state.BASE_URI + 'admin/vouchers/load_vtype_by_provider', {
          headers: { Authorization: localStorage.getItem('accessToken') },
          params: {
            voucher_id: this.selectedProviderId,
          },
        })
        .then((res) => {
          this.dropDownVoucherInfo = res.data.results;
        });
    },
    onOptionChangeVoucher(e) {
      this.validateForm;
    },
    onFileChange(e) {
      const btn = document.querySelector('#submit_import');
      if (
        e.target.files[0].name.indexOf('csv') != -1 ||
        e.target.files[0].name.indexOf('xlsx') != -1
      ) {
        this.selectedFile = e.target.files[0];
        this.errorMsg = '';
        btn.disabled = false;
      } else {
        this.selectedFile = null;
        this.errorMsg = 'Wrong file format. Please import CSV or Excel format.';
        document.getElementById('importFile').value = '';
        btn.disabled = true;
      }
    },
    loadProviderFilter() {
      axios
        .get(store.state.BASE_URI + 'admin/vouchers/load_providers', {
          headers: { Authorization: localStorage.getItem('accessToken') },
          params: {},
        })
        .then((res) => {

          this.providerFilterSelect = res.data.results;
        });
    },
    triggerDownload() {
      this.downloadActivity = true;
    },
    ExportResults(
      page = 1,
      perpage = 3000,
      search = this.searchVoucher,
      order = this.orderVoucher,
      sort = this.sortVoucher,
      status = this.filterStatus,
      total = this.meta_data_voucher.total,
      provider = this.filterProvider
    ) {
      axios
        .get(store.state.BASE_URI + 'admin/vouchers/load_vouchers_stats_info', {
          headers: {
            Authorization: localStorage.getItem('accessToken'),
            'Content-Type': 'text/plain;charset=utf-8',
          },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            status,
            total,
            provider
          },
        })
        .then((res) => {
          getReport(res.data.results.voucher_stats);
          this.downloadActivity = false;
        });

      //  getReport( this.voucher_stats);
    },
    ClearFilters() {

      this.meta_data_voucher.current_page = 1,
        this.meta_data_voucher.perpage = 5,
        this.searchVoucher = null,
        this.orderVoucher = null,
        this.sortVoucher = null,
        this.filterStatus = [],
        this.filterProvider = null,
        this.fetchVoucherResults(
          this.meta_data_voucher.current_page,
          this.meta_data_voucher.perpage,
          this.searchVoucher,
          this.orderVoucher,
          this.sortVoucher,
          this.filterStatus,
          this.filterProvider
        );

    },
  },
};
const objectToCsv = function (data) {
  //  console.log(data);
  const csvRows = [];

  //  // add headers
  const headers = ['Provider Name', 'Voucher type Name', 'Code', 'Value', 'Status', 'User', 'Assigned on'];
  csvRows.push(headers.join(','));

  //  // add statistics

  for (const row of data) {
    var status;
    switch (row.status) {
      case '0':
        status = 'Used';
        break;
      case '1':
        status = 'Free';
        break;
      case '2':
        status = 'Assigned';
        break;
    }


    const values2 = [
      row.service_name,
      row.name_mk,
      row.code,
      row.value,
      status,
      row.username == null ? 'Not assigned to user' : row.username,
      row.assigned_on == null ? '/' : row.assigned_on
    ];
    csvRows.push(values2.join(','));
  }

  csvRows.push(['\n'].join(','));


  return csvRows.join('\n');
};
const download = function (data, fileName) {
  const BOM = '\uFEFF';
  const csvData = BOM + data;
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
  //  const blob = new Blob([data], { type: 'text/csv;charset=utf-8'});
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', fileName + '.csv');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
const getReport = async function (reportInfo) {
  const res = reportInfo;
  const csvData = objectToCsv(res);
  const today = new Date().toISOString().slice(0, 10);
  //  console.log(csvData);
  download(csvData, 'vouchers_report_' + today);
};
</script>

<style src="../css/style.css"></style>